import {getPageNodes} from '@packages/shared/utils/PageTreeUtils';
import {abilityFeature} from '../abilityFeature';

export const pageScope = abilityFeature({
  key: 'pageScope',
  isValid(state, scopes, options) {
    const pageId = options?.pageId ?? state.DesignerStore?.currentPageId;
    const page =
      state.PageStore && pageId
        ? getPageNodes(state.PageStore).get(pageId)
        : undefined;
    // Tree swaps can precede the current-page update during branch switches.
    if (!page) return false;

    return scopes.includes(
      page.branchId ? (page.branchRole ? 'siteBranch' : 'pageBranch') : 'main'
    );
  },
});
